import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TxDragDropService } from './tx-drag-drop-upload.service';

@Component({
  selector: 'txDragDropUpload',
  exportAs: 'txDragDropUpload',
  templateUrl: './tx-drag-drop-upload.component.html',
  styleUrls: ['./tx-drag-drop-upload.component.scss'],
})
export class TxDragDropUploadComponent implements OnInit {
  fileQueue: File[] = [];

  @Input() zone = 'zone';
  @Input() showList = false;

  @Output() fileChanged: EventEmitter<File[]> = new EventEmitter<File[]>();

  constructor(private _uploadService: TxDragDropService) {}

  ngOnInit(): void {
    this.fileQueue = this._uploadService.files;
  }

  onFileAdded(fileList: FileList) {
    Array.from(fileList).forEach((file) => this.fileQueue.push(file));
    this._uploadService.files = this.fileQueue;
    this.fileChanged.emit(this.fileQueue);
  }

  onFileRemoved(file: File) {
    this.fileQueue = this.fileQueue.filter((f) => f !== file);
    this._uploadService.files = this.fileQueue;
    this.fileChanged.emit(this.fileQueue);
  }
}
